export interface MeetingAttendanceEvaluatorData {
  tooltip_summary: string;
  from_date: string;
  to_date: string;
  total_assisted: number;
  total_no: number;
  total_yes_but_late: number;
  total_on_another_meeting: number;
  total_attendances: number;
  total_force_majeure: number;
  total_didnt_have_to_attend: number;
}

export const MEETING_ATTENDANCE_DEFAULT: MeetingAttendanceEvaluatorData = {
  tooltip_summary: '',
  from_date: '',
  to_date: '',
  total_attendances: 0,
  total_assisted: 0,
  total_yes_but_late: 0,
  total_no: 0,
  total_on_another_meeting: 0,
  total_force_majeure: 0,
  total_didnt_have_to_attend: 0,
};
